module.exports = __webpack_public_path__ + "static/media/DSF.76cf127a.svg";